(function () {
  function initializeUgcFold(section) {
    if (!section || section.dataset.playControlReady === 'true') return;

    var video = section.querySelector('.jci-waggle-ugc-fold__video-frame video');
    var toggle = section.querySelector('.jci-waggle-ugc-fold__play-toggle');

    if (!video || !toggle) return;

    section.dataset.playControlReady = 'true';
    video.controls = false;
    video.removeAttribute('controls');
    toggle.hidden = false;

    var playbackStarting = false;

    toggle.addEventListener('click', async function () {
      if (playbackStarting) return;

      playbackStarting = true;
      toggle.hidden = true;

      try {
        await video.play();
        video.controls = true;
      } catch (error) {
        video.controls = false;
        video.removeAttribute('controls');
        toggle.hidden = false;
      } finally {
        playbackStarting = false;
      }
    });

    video.addEventListener('ended', function () {
      video.controls = false;
      video.removeAttribute('controls');

      try {
        video.currentTime = 0;
      } catch (error) {
        // Some browsers may not allow seeking until metadata is ready.
      }

      toggle.hidden = false;
    });
  }

  function initializeAllUgcFolds(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('.jci-waggle-ugc-fold')) {
      initializeUgcFold(scope);
    }

    scope.querySelectorAll('.jci-waggle-ugc-fold').forEach(initializeUgcFold);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllUgcFolds(document);
    });
  } else {
    initializeAllUgcFolds(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllUgcFolds(event.target);
  });
})();
